export default {
  cake: {
    97: '0x71240D6160438dAbD0e95def72C29B1Dd493d8dE',
    56: '0x1f36f067f4e425994763da9ee5bcc76f154c82d1',
  },
  // syrup: {
  //   97: '0x6e6059CdcF38252B9ad5DC743e7ea27B4E8a3e49',
  //   56: '0x009cF7bC57584b7998236eff51b98A168DceA9B0',
  // },
  

  casino: {
    97: '0xAdfcC9eBD4d3dCAe8d41604B175fa25cDCe75044',
    56: '0x965ede0910eB6be4b233E3cc0b077eC06072F4af',
  },

  dot: {
    97: '0xAdfcC9eBD4d3dCAe8d41604B175fa25cDCe75044',
    56: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
  },


  masterChef: {
    97: '0xD787843CdB3125BeD5830221cb7DBb063ade7200',
    56: '0xd12a952f87e8d5d58c8ca55ce083e5f7a34fd4e3',
  },
  // sousChef: {
  //   97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
  //   56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  // },
  wbnb: {
    97: '0xA73D61379627dB94f968C7bb4BD7fF5c07723Ec2',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  },
  lottery: {
    97: '0x0B37Ab7C7Dc1177dc73BB804FEf4A24A9446904d',
    56: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
  },
  lotteryNFT: {
    97: '0x14276AdAD51E99C76A5997A9b7e392901497C7d3',
    56: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0x4998c1031e1c9cd49fe31f6786a0e6090fda95ea',
  },





  
  ust: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '',
  },
  // pancakeProfile: {
  //   56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
  //   97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  // },
  // pancakeRabbits: {
  //   56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
  //   97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  // },
  // bunnyFactory: {
  //   56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
  //   97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  // },
  // eth: {
  //   56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
  //   97: '0xd0b4c1b5d59aa41e522699b6e469704916faed95',
  // },
  // claimRefund: {
  //   56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
  //   97: '',
  // },
  // pointCenterIfo: {
  //   56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
  //   97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  // },
  // bunnySpecial: {
  //   56: '0xFee8A195570a18461146F401d6033f5ab3380849',
  //   97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  // },
}
